import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_slsodr_to_slsinv_consol_run_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    prev_run_hdr_guid: fromDatatype.GuidDataFieldInterface;
    template_hdr_guid: fromDatatype.GuidDataFieldInterface;
    event_hdr_guid: fromDatatype.GuidDataFieldInterface;
    run_name: fromDatatype.VarcharDatatypeInterface;
    company_json: fromDatatype.JsonDatatypeInterface;
    branch_json: fromDatatype.JsonDatatypeInterface;
    customer_json: fromDatatype.JsonDatatypeInterface;
    salesman_json: fromDatatype.JsonDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    start_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    processor_posting_status: fromDatatype.VarcharDatatypeInterface;
    processor_posting_error: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_slsodr_to_slsinv_consol_run_hdr_RowClass
    implements bl_fi_slsodr_to_slsinv_consol_run_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    prev_run_hdr_guid: fromDatatype.GuidDataFieldInterface;
    template_hdr_guid: fromDatatype.GuidDataFieldInterface;
    event_hdr_guid: fromDatatype.GuidDataFieldInterface;
    run_name: fromDatatype.VarcharDatatypeInterface;
    company_json: fromDatatype.JsonDatatypeInterface;
    branch_json: fromDatatype.JsonDatatypeInterface;
    customer_json: fromDatatype.JsonDatatypeInterface;
    salesman_json: fromDatatype.JsonDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    start_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    processor_posting_status: fromDatatype.VarcharDatatypeInterface;
    processor_posting_error: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
